import { useQuery } from "@tanstack/react-query";

import { useDomainServices } from "@/providers/DomainServices";

import type { S3BucketIntegrationRecord } from "../S3BucketIntegrationRecord";

import { integrationQueryKeys } from "./integrationQueryKeys";

/**
 * Every org a bucket name is registered to.
 *
 * Read when browsing a bucket fails because the active org has no registration for it, so the
 * page can offer the orgs that do instead of a bare not-found.
 */
export function useS3BucketBindings(bucketName: string) {
  const { integrationService } = useDomainServices();

  return useQuery<S3BucketIntegrationRecord[], Error>({
    queryKey: integrationQueryKeys.s3Bindings(bucketName),
    queryFn: ({ signal }) =>
      integrationService.getS3BucketBindings(bucketName, {
        abortSignal: signal,
      }),
    enabled: bucketName.length > 0,
    staleTime: 60_000,
  });
}
